<template>
  <div class="app-main-content intelligent-booking">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleClick">
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_RuleConfig')" name="ruleConfig" style="width:100%;height: 100%">
          <rule-config ref="ruleConfig" :tab-title="$t('CargoMsg.Cargo_RuleConfig')" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_RuleApplication')" name="ruleApplication" style="width:100%;height: 100%">
          <rule-application ref="ruleApplication" :tab-title="$t('CargoMsg.Cargo_RuleApplication')" />
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>

<script>

import RuleConfig from '@/views/cargo/v0/Performance/tabPane/ruleConfig.vue'
import RuleApplication from '@/views/cargo/v0/Performance/tabPane/ruleApplication.vue'

export default {
  name: 'AIEngine',
  components: { RuleApplication, RuleConfig },
  data() {
    return {
      activeTabName: 'ruleConfig'
    }
  },
  activated() {},
  async created() {
  },
  methods: {
    handleClick() {
      this.$nextTick(() => {
        this.$refs[this.activeTabName].init()
      })
    }
  }
}
</script>

<style scoped>

</style>
